import React from "react";
import Logo1 from "./Icons/logo.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  // const [mode, setMode] = useState(false);
  // const modeSet = () => {
  //   setMode(!mode);
  // }

  return (
    <div
      className="nav-top"
      //   style={
      //     mode == true
      //       ? { "background-color": "black" }
      //       : { "background-color": "white" }
      //   }
      // style={mode == true ? { color: "white" } : { color: "black" }}
    >
      <div className="nav-top__left">
        <Link className="nav-top-logo nav-top-logo-link" to="/">
          <img
            className="nav-top-logo"
            src={Logo1}
            alt="this is my web site main image"
          />
          <p className="nav-top-name">Istam</p>
        </Link>
      </div>
      <div className="nav-top__right">
        <ul className="menu-items">
          <li className="menu-item">
            <Link to="/" className="menu-link">
              Home
            </Link>
            <span className="menu-item__bottom"></span>
          </li>
          <li className="menu-item">
            <Link to="/aboutme" className="menu-link">
              About me
            </Link>
            <span className="menu-item__bottom"></span>
          </li>
          <li className="menu-item">
            <Link to="/projects" className="menu-link">
              Projects
            </Link>
            <span className="menu-item__bottom"></span>
          </li>
          <li className="menu-item">
            <Link to="/blog" className="menu-link">
              Blog
            </Link>
            <span className="menu-item__bottom"></span>
          </li>

          <li className="menu-item">
            <Link to="/contact" className="menu-link">
              Contact
            </Link>
            <span className="menu-item__bottom"></span>
          </li>
        </ul>
      </div>

      {/* <div className="mode">
        <div className="mode-button" onClick={modeSet}></div>
      </div> */}
    </div>
  );
};

export default Navbar;
